/* RIPPLE-01 (owner 2026-10-09: "a slow slow ripple feel to the entire page, similar to the drop down menu").
   Scroll ripple: when a section comes into view its heading eases up first, then its cards follow one after another,
   left to right, on the menu's glide curve (CSS: "RIPPLE-01" in assets/sz-pm-fixes.css).
   Guard rails:
   - only content BELOW the first screen is ever hidden, so the hero, the LCP image and anything already on screen are
     never touched (no load-speed cost);
   - nothing is hidden unless this script runs (the classes come from here), and reduced motion, the theme editor and
     browsers without IntersectionObserver get no ripple at all;
   - IntersectionObserver only, never scroll listeners; opacity + transform only, so nothing shifts the layout;
   - a horizontal row reveals as one, so the card peeking at its edge is never left blank;
   - keyboard focus reveals a waiting block at once.
   Revert: remove the script tag in layout/sz-redesign.liquid. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  if (!('IntersectionObserver' in window) || !window.matchMedia) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var UNITS = [
    /* premium sections */
    'main .section-heading', 'main .category-intro', 'main .care-intro',
    'main .sz-pm-catalogue__head', 'main .sz-pm-catalogue__week', 'main .sz-pm-catalogue__way', 'main .sz-pm-catalogue__index-title',
    'main .sz-pm-catalogue__row', 'main .sz-pm-catalogue__toollist > li', 'main .sz-pm-catalogue__linesnote',
    'main .sz-gc__head', 'main .sz-gc__lines', 'main .sz-gc__line',
    'main .final-products > .product-card', 'main .sz-pm-shopby__tile', 'main .category-tile', 'main .guide-grid > .guide',
    'main .sz-pm-edit', 'main .sz-pm-dial', 'main .final-newsletter',
    'main .story-copy', 'main .specimen-image', 'main .specimen-facts',
    '.sz-pm-pdp .product-story', '.sz-pm-pdp .sz-pm-plate', '.sz-pm-pdp .product-details > .detail-group',
    '.sz-pm-pdp .sz-pm-journey', '.sz-pm-pdp .sz-rd-faq', '.sz-pm-related__row > h2', 'main .shopify-app-block',
    /* older sections still used on a few pages (blog, cart, info pages) */
    'main .sz-rd-card', 'main .sz-rd-cat', 'main .sz-rd-why__card', 'main .sz-rd-guide', 'main .sz-rd-review',
    'main .sz-rd-tier', 'main .sz-rd-blogcard', 'main .sz-rd-h',
    /* footer */
    '.premium-footer__main > *', '.premium-footer__base'
  ].join(',');
  /* never ripple inside these: the hero, buy controls, overlays, the auction panel */
  var ZONES = '.hero, .selection-grid, .sz-alot, .sz-alot-bar, .sz-pm-sheet, .sz-rd-menu, .sz-rd-cartqv, .sz-pm-zoom, [data-no-ripple]';
  var STEP = 85, MAXSTEP = 8, FINE = matchMedia('(hover: hover) and (pointer: fine)').matches;

  function scrollerOf(el) {
    for (var p = el.parentElement, i = 0; p && i < 4; p = p.parentElement, i++) {
      var o = getComputedStyle(p).overflowX;
      if ((o === 'auto' || o === 'scroll') && p.scrollWidth > p.clientWidth + 2) return p;
    }
    return null;
  }

  function reveal(el, delay) {
    io.unobserve(el);
    if (!el.classList.contains('sz-rip-wait')) return;
    el.style.setProperty('--sz-rip-d', delay + 'ms');
    el.classList.add('sz-rip-in');
    el.classList.remove('sz-rip-wait');
    setTimeout(function () { el.classList.remove('sz-rip-in'); el.style.removeProperty('--sz-rip-d'); }, delay + 1900);
  }

  var io = new IntersectionObserver(function (entries) {
    var batch = [];
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var sc = e.target.__szRipSc, list = sc ? sc.querySelectorAll('.sz-rip-wait') : [e.target];
      for (var i = 0; i < list.length; i++) if (batch.indexOf(list[i]) < 0) batch.push(list[i]);
    });
    if (!batch.length) return;
    /* top to bottom, then left to right: a heading leads, a row of cards ripples across */
    batch.map(function (el) { var r = el.getBoundingClientRect(); return { el: el, t: Math.round(r.top / 12), l: r.left }; })
      .sort(function (a, b) { return a.t - b.t || a.l - b.l; })
      .forEach(function (p, i) { reveal(p.el, Math.min(i, MAXSTEP) * STEP); });
  /* mouse: starts once a block is in view, so the ripple is seen; touch: starts a fifth of a screen early, so a quick flick
     never lands on blank space */
  }, { rootMargin: FINE ? '0px 0px -6% 0px' : '0px 0px 20% 0px' });

  function setup(scope) {
    var list = scope.querySelectorAll(UNITS), vh = innerHeight, pick = [], i, el;
    for (i = 0; i < list.length; i++) {
      el = list[i];
      if (el.__szRip) continue;
      el.__szRip = 1;
      if (el.closest(ZONES)) continue;
      var up = el.parentElement;
      if (up && (up.closest(UNITS) || up.closest('details:not([open])'))) continue; /* outermost block only; closed accordions stay as they are */
      pick.push(el);
    }
    /* read every position first, then write, so the page is laid out once */
    var rects = pick.map(function (x) { return x.getBoundingClientRect(); });
    pick.forEach(function (x, k) {
      var r = rects[k];
      if (!r.width && !r.height) return;   /* not displayed */
      if (r.top < vh) return;              /* on or above the first screen: never hidden */
      x.__szRipSc = scrollerOf(x);
      x.classList.add('sz-rip-wait');
      io.observe(x);
    });
  }

  /* the class goes on at once (it hides nothing by itself, and tells sz-rd-motion.js to stand down); the scan waits for
     an idle moment so it never competes with the first paint. Anything the visitor has already scrolled to by then is
     simply left visible. */
  root.classList.add('sz-rip');
  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 200); };

  d.addEventListener('focusin', function (e) {
    var u = e.target.closest && e.target.closest('.sz-rip-wait');
    if (u) reveal(u, 0);
  });
  window.addEventListener('beforeprint', function () {
    d.querySelectorAll('.sz-rip-wait').forEach(function (el) { reveal(el, 0); });
  });

  /* cards added later (filters, load more, review widgets) ripple in too; watching starts after the first scan */
  var mainEl = d.querySelector('main'), mt;
  idle(function () {
    setup(d);
    if (mainEl && window.MutationObserver) {
      new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { clearTimeout(mt); mt = setTimeout(function () { idle(function () { setup(mainEl); }, { timeout: 1000 }); }, 80); return; }
      }).observe(mainEl, { childList: true, subtree: true });
    }
  }, { timeout: 1200 });
})();
